import { useRef } from "react";

const THRESHOLD = 50;

// Touch handlers that report the dominant swipe direction; onDrag gets live dx for drag-follow effects.
export function useSwipe({ onLeft, onRight, onUp, onDown, onDrag } = {}) {
  const start = useRef(null);

  const onTouchStart = (e) => {
    const t = e.touches[0];
    start.current = { x: t.clientX, y: t.clientY };
  };

  const onTouchMove = (e) => {
    if (!start.current || !onDrag) return;
    const t = e.touches[0];
    const dx = t.clientX - start.current.x;
    const dy = t.clientY - start.current.y;
    if (Math.abs(dx) > Math.abs(dy)) onDrag(dx);
  };

  const onTouchEnd = (e) => {
    if (!start.current) return;
    const t = e.changedTouches[0];
    const dx = t.clientX - start.current.x;
    const dy = t.clientY - start.current.y;
    start.current = null;
    onDrag?.(0);
    if (Math.abs(dx) > Math.abs(dy)) {
      if (dx <= -THRESHOLD) onLeft?.();
      else if (dx >= THRESHOLD) onRight?.();
    } else if (dy <= -THRESHOLD) onUp?.();
    else if (dy >= THRESHOLD) onDown?.();
  };

  return { onTouchStart, onTouchMove, onTouchEnd, onTouchCancel: () => { start.current = null; onDrag?.(0); } };
}
